import { Pallet } from '@/generated/model/pallet'

export class PalletDef {
  width: number = 0
  height: number = 0
  overhangL: number = 0
  overhangB: number = 0
  overhangR: number = 0
  overhangT: number = 0
  topLeftX: number = 300
  topLeftY: number = 40
  dropZoneX: number = 300
  displayRotation: number = 0
}

export function getPalletDef (pallet: Pallet): PalletDef {
  const palDef = new PalletDef()
  palDef.width = pallet.length!
  palDef.height = pallet.width!
  palDef.overhangL = pallet.overhangL || 0
  palDef.overhangR = pallet.overhangR || 0
  palDef.overhangB = pallet.overhangB || 0
  palDef.overhangT = pallet.overhangT || 0
  palDef.displayRotation = pallet.displayRotation || 0
  return palDef
}
